// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1osRM","content":"LoadingAlert_content__1-aB4"};